import { Component, Input } from '@angular/core';
import { RouteSheetLocationDTO } from 'src/app/features/locations-map/models/RouteSheetLocationDTO';
import { RouteSheetService } from 'src/app/features/locations-map/services/RouteSheet.service';

@Component({
  selector: "route-sheet-generic-card",
  templateUrl: "./generic-card.component.html",
  styleUrls: ["./generic-card.component.css"],
})
export class RouteSheetGenericCardComponent {
  @Input() routeSheetLocation: RouteSheetLocationDTO;
  @Input() skeletonLoading: boolean = false;

  constructor(private routeSheetService: RouteSheetService) {}
}
